import React from "react";
import {graphql, useStaticQuery} from "gatsby";
import BackgroundImage from "gatsby-background-image";

const BackgroundImage_Footer = (
  {
    children,
    name
  }
) => {
  const data = useStaticQuery(
    graphql`
        query {
            backgrounds: allFile(
                filter: { relativePath: { in: ["background-footer.jpg", "background-footer-mini.jpg"] } }
            ) {
                nodes {
                    name
                    childImageSharp {
                        fluid(maxWidth: 1920) {
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
            }
        }
    `
  )

  return (
    <BackgroundImage
      fluid={data?.backgrounds?.nodes?.find(one => one?.name === name)?.childImageSharp?.fluid}
      style={styleBackgroundStars}
    >
      {children}
    </BackgroundImage>
  )
}

export default BackgroundImage_Footer;

const styleBackgroundStars = {
  width: '100%',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'top',
  backgroundPositionX: 'right'
}
